/* eslint-disable no-console */
export default function removeRecentSearchActionCreator(recentSearchDuck, personalization) {
  return _ref => {
    let {
      key
    } = _ref;
    return async dispatch => {
      try {
        // attempt to update local storage when it's considered as a "new" search
        const {
          items
        } = await personalization.removeInventorySearch({
          heading: key
        });
        dispatch(recentSearchDuck.creators.setRecentSearches(items));
      } catch (error) {
        console.log(error);
      }
    };
  };
}